import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { toast } from 'sonner';

const DemoForm = () => {

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "48114061",
          formId: "aa935b06-737d-41d0-b162-f871af74445c",
          region: "na1",
          target: '#hubspotFormDemo',
          onFormSubmitted: function ($form) {
            toast.success('Demo request submitted! We\'ll contact you within 24 hours.');
          }
        });
      }
    });
  }, []);

  return (
    <section id="demo" className="pt-12 pb-24 bg-[#101F27] relative overflow-hidden scroll-mt-20">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(0,217,255,0.05),transparent_70%)]"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-start">
          {/* Left Content */}
          <div>
            <p className="text-sm font-semibold text-[#009688] uppercase tracking-wide mb-4">
              Contact Us
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              See{' '}
              <span className="text-white">
                WristCoin
              </span>{' '}
              in Action
            </h2>
            <p className="text-xl text-gray-400 mb-2">
              Schedule a one-on-one call and discover how WristCoin can transform your operations. If you're looking for customer support, <Link to="/support" className="text-[#009688] hover:underline">find us here</Link>.
            </p>
          </div>

          {/* Right Content - Form */}
          <Card className="bg-[#37464F]/80 backdrop-blur-lg border-gray-800 shadow-2xl">
            <CardContent className="p-8">
                <div id="hubspotFormDemo"/>
            </CardContent>
          </Card>
        </div>

        {/* Trust Indicators - Below Form */}
        <div className="mt-16 pt-8 border-t border-gray-800 max-w-3xl mx-auto text-center">
          <p className="text-sm text-gray-500 mb-6">Trusted by 100+ Global Brands</p>
          <div className="flex items-center justify-center space-x-10 md:space-x-16">
            <div>
              <div className="text-3xl font-bold text-[#009688]">24hrs</div>
              <div className="text-xs text-gray-400 mt-1">Response Time</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-[#009688]">5★</div>
              <div className="text-xs text-gray-400 mt-1">Average Rating</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-[#009688]">100%</div>
              <div className="text-xs text-gray-400 mt-1">Customer Satisfaction</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DemoForm;
